import {
  instanceConfigMetadata,
  instanceDisruptionLineAPI as srgLinesAPI,
} from "api";
import { initiateAXIOS } from "config/axios";
import {
  SET_SRGLINES_DATA,
  SET_LOADING_SRGLINES_DATA,
  SET_ERROR_MESSAGE_SRGLINES_PAGE,
  SET_ERROR_PROMPT_SRGLINES_PAGE,
  SET_SUCCESS_MESSAGE_SRGLINES_PAGE,
  SET_SUCCESS_PROMPT_SRGLINES_PAGE,
  SET_EDIT_SRGLINES_DATA,
} from "../../actionTypes/smrt/srgLinesActionType";
import { handleError } from "store/handleError";
import { logger } from "helpers/logger";

import i18n from "i18next";
const t = i18n.getFixedT(null, "srgLines");

const handleTimeoutSuccessPrompt = (dispatch) => {
  setTimeout(() => {
    dispatch({ type: SET_SUCCESS_PROMPT_SRGLINES_PAGE, payload: false });
  }, 5000);
};

const handleTimeoutErrorPrompt = (dispatch) => {
  setTimeout(() => {
    dispatch({ type: SET_ERROR_PROMPT_SRGLINES_PAGE, payload: false });
  }, 5000);
};

export const getSrgLines = ({ payload, cache, append, filter }, callback) => {
  const access_token = sessionStorage.getItem("access_token");

  return async (dispatch) => {
    logger.log(`getSrgLines:`, { payload, cache, append, filter });
    if (filter || cache?.items?.length === 0) {
      dispatch({ type: SET_LOADING_SRGLINES_DATA, payload: true });
    }

    const {
      limit,
      offset,
      // type,
      nameLike,
      codeLike,
      sortBy,
      // searchDate,
      // searchByTags,
    } = payload;
    let getURL = `${srgLinesAPI}`;
    if (limit >= 0) {
      getURL += `?limit=${limit || 10}`;
    }

    // // parsing payload to query
    getURL += `&offset=${offset || 0}`;
    if (nameLike?.length > 0) {
      getURL += `&nameLike=${nameLike}`;
    }
    if (codeLike?.length > 0) {
      getURL += `&codeLike=${codeLike}`;
    }
    // if (type?.length > 0) {
    //   getURL += `&type=${type}`;
    // } else {
    //   getURL += `&type=IMAGE&type=VIDEO`;
    // }
    if (sortBy?.length > 0) {
      getURL += `&sortBy=${sortBy}`;
    } else {
      getURL += `&sortBy=idAsc`;
    }
    // if (searchDate?.length > 0) {
    //   const startAt = `${searchDate}T00:00:00Z`;
    //   const endAt = `${searchDate}T23:59:59Z`;
    //   getURL += `&createdAtGte=${startAt}`;
    //   getURL += `&createdAtLte=${endAt}`;
    // }
    // if (searchByTags?.length > 0) {
    //   searchByTags.forEach((tag) => {
    //     getURL += `&tag=${tag}`;
    //   });
    // }
    // getURL += `&isPublic=false`;

    try {
      const { data } = await initiateAXIOS.get(getURL, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      let fetchedData = [];
      const items = data.items;
      // console.log(`getSrgLines-items:`, items);
      for (let i = 0; i < items.length; i++) {
        fetchedData.push(items[i]);
      }

      let updated = cache?.items;
      if (append && cache?.items?.length > 0) {
        let appendedLength = cache.items.length + limit;
        if (appendedLength <= offset) {
          const paddingLength = offset - appendedLength + limit;
          const paddingArray = new Array(paddingLength)
            .fill({})
            .map((_, index) => {
              return {
                id: index + 1,
                name: "..........",
                campaignName: ".....",
              };
            });
          updated = updated.concat(paddingArray);
        }

        updated = updated.concat(fetchedData);
        dispatch({
          type: SET_SRGLINES_DATA,
          payload: {
            items: updated,
            totalItem: data.totalItem,
          },
        });
      } else {
        if (cache?.items?.length > 0 && !filter) {
          updated.splice(offset, limit, ...fetchedData);
          dispatch({
            type: SET_SRGLINES_DATA,
            payload: {
              items: updated,
              totalItem: data.totalItem,
            },
          });
        } else {
          dispatch({
            type: SET_SRGLINES_DATA,
            payload: {
              items: fetchedData,
              totalItem: data.totalItem,
            },
          });
        }
      }
    } catch (e) {
      logger.error(`Error-getSrgLines:`, e);
      const message = handleError(e);
      dispatch({ type: SET_ERROR_PROMPT_SRGLINES_PAGE, payload: true });
      dispatch({ type: SET_ERROR_MESSAGE_SRGLINES_PAGE, payload: message });

      handleTimeoutErrorPrompt(dispatch);
      if (e.response?.status >= 500) {
        throw new Error(JSON.stringify(e.response?.data) || message);
      }
    } finally {
      dispatch({ type: SET_LOADING_SRGLINES_DATA, payload: false });
      if (callback) callback();
    }
  };
};

export const editSrgMetadata = (payload, callback) => {
  const access_token = sessionStorage.getItem("access_token");

  return async (dispatch) => {
    try {
      await initiateAXIOS.patch(instanceConfigMetadata, payload, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      callback("success", payload);
      dispatch({ type: SET_SUCCESS_PROMPT_SRGLINES_PAGE, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_SRGLINES_PAGE,
        payload: t("api.updateInfoTextSize"),
      });
      handleTimeoutSuccessPrompt(dispatch, SET_SUCCESS_PROMPT_SRGLINES_PAGE);
    } catch (error) {
      const errorMessage = handleError(error);
      logger.error(errorMessage);
      dispatch({ type: SET_ERROR_PROMPT_SRGLINES_PAGE, payload: true });
      dispatch({
        type: SET_ERROR_MESSAGE_SRGLINES_PAGE,
        payload: errorMessage,
      });
      handleTimeoutErrorPrompt(dispatch, SET_ERROR_PROMPT_SRGLINES_PAGE);

      callback("error");
    }
  };
};

export const editSrgLineStatus = (payload) => {
  const access_token = sessionStorage.getItem("access_token");

  return async (dispatch) => {
    dispatch({ type: SET_LOADING_SRGLINES_DATA, payload: true });

    try {
      const { data } = await initiateAXIOS.patch(
        srgLinesAPI + payload.id + "/status",
        {
          status: payload.status,
          info: payload.info?.length === 0 ? "—" : payload.info,
        },
        {
          headers: { authorization: `Bearer ${access_token}` },
        },
      );

      dispatch({ type: SET_EDIT_SRGLINES_DATA, payload: data });
      dispatch({ type: SET_SUCCESS_PROMPT_SRGLINES_PAGE, payload: true });
      dispatch({
        type: SET_SUCCESS_MESSAGE_SRGLINES_PAGE,
        payload: `[${data?.name}] ${t("api.updateMsg")}`,
      });
      handleTimeoutSuccessPrompt(dispatch, SET_SUCCESS_PROMPT_SRGLINES_PAGE);
    } catch (error) {
      const errorMessage = handleError(error);
      logger.error(errorMessage);
      dispatch({ type: SET_ERROR_PROMPT_SRGLINES_PAGE, payload: true });
      dispatch({
        type: SET_ERROR_MESSAGE_SRGLINES_PAGE,
        payload: errorMessage,
      });
      handleTimeoutErrorPrompt(dispatch, SET_ERROR_PROMPT_SRGLINES_PAGE);
    } finally {
      dispatch({ type: SET_LOADING_SRGLINES_DATA, payload: false });
    }
  };
};
